import { render, staticRenderFns } from "./TaskNavMenu.vue?vue&type=template&id=88a5f3ac&"
import script from "./TaskNavMenu.vue?vue&type=script&lang=js&"
export * from "./TaskNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./TaskNavMenu.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TaskNavMenu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VList})
